module.exports = __webpack_public_path__ + "static/media/Arrow.c4719248.svg";